import React from 'react';
import './Hero.css';
import { useLanguage } from '../context/LanguageContext';

const Hero = () => {
  const { t } = useLanguage();
  return (
    <section className="hero">
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-left">
            <div className="hero-text">
              <h1 className="hero-title">
                <span className="title-light">{t.hero.title1}</span>
                <br />
                <span className="title-bold">{t.hero.title2}</span>
                <br />
                <span className="title-italic">{t.hero.title3}</span>
              </h1>
              
              <p className="hero-paragraph">
                {t.hero.paragraph}
              </p>
              
              <div className="hero-download-section">
                <div className="hero-store-buttons">
                  <a href="#" className="hero-store-button">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
                    </svg>
                    <div className="hero-store-text">
                      <span className="hero-store-label">{t.hero.appStore}</span>
                      <span className="hero-store-name">{t.hero.appStoreName}</span>
                    </div>
                  </a>
                  
                  <a href="#" className="hero-store-button">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 01-.61-.92V2.734a1 1 0 01.609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-3.198l2.807 1.626a1 1 0 010 1.73l-2.807 1.626L15.206 12l2.492-2.491zM5.864 2.658L16.8 8.99l-2.302 2.302-8.634-8.634z"/>
                    </svg>
                    <div className="hero-store-text">
                      <span className="hero-store-label">{t.hero.googlePlay}</span>
                      <span className="hero-store-name">{t.hero.googlePlayName}</span>
                    </div>
                  </a>
                </div>
                
              </div>
            </div>
          </div>

          <div className="hero-right">
            <div className="hero-image-wrap">
              <img 
                src={`${process.env.PUBLIC_URL || ''}/hero-image.png`} 
                alt="Raahi — friendly service, one platform" 
                className="hero-image-only"
              />
            </div>
          </div>
        </div>
      </div>
      
      <div className="hero-background-pattern"></div>
      <div 
        className="hero-map-bg" 
        aria-hidden="true" 
        style={{ backgroundImage: `url(${process.env.PUBLIC_URL || ''}/map.svg)` }}
      />
    </section>
  );
};

export default Hero;
